export default __webpack_public_path__ + "static/media/logo.34752c83.png";